import styled, { css } from 'styled-components';

interface LoaderContainerProps {
  $fullscreen: boolean;
}

export const LoaderContainer = styled.div<LoaderContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ $fullscreen }) =>
    $fullscreen &&
    css`
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255, 0.7);
    `}
`;

export const LoaderWrapper = styled.div`
  width: 50px;
  height: 50px;
`;
